<div class="mini-app-bar">
  <a href="/"><img src="assets/images/small-logo.png" /></a>
</div>
<div class="content-holder">
  <div class="doc-content">
    <h1 class="c12"><span>Privacy Policy for The Card Professor Inc</span></h1>
    <h2 class="c4"><span class="c3">Introduction</span></h2>
    <p class="c1">
      <span class="c0"
        >This Privacy Policy outlines the manner in which The Card Professor Inc
        (&quot;the Company&quot;), as the Data Controller, collects, uses,
        maintains, and discloses information collected from users (each, a
        &quot;User&quot;) of its services. The practices described in this
        policy are specifically tailored to comply with the legal requirements
        of Lake County, Illinois, and are designed to protect the privacy and
        security of the User&#39;s information.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >The Company is committed to conducting its business in accordance with
        these principles in order to ensure that the confidentiality of personal
        information is protected and maintained. This policy applies to all
        information collected by the Company through its services and
        platforms.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Information Collection</span></h2>
    <p class="c1">
      <span
        >This Privacy Policy outlines the types of information that The Card
        Professor Inc (&quot;We&quot;, &quot;Us&quot;, &quot;Our&quot;, or
        &quot;Company&quot;) may collect from you (&quot;User&quot;) or that you
        may provide when you visit any website, mobile application, or other
        digital service operated by The Card Professor Inc (collectively, the
        &quot;Services&quot;), and our practices for collecting, using,
        maintaining, protecting, and disclosing that information.</span
      >
    </p>
    <p class="c1">
      <span class="c0">This policy applies to information we collect:</span>
    </p>
    <ul class="c7 lst-kix_list_1-0 start">
      <li class="c8 li-bullet-0"><span class="c0">On this Website.</span></li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >In email, text, and other electronic messages between you and this
          Website.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Through mobile and desktop applications you download from this
          Website, which provide dedicated non-browser-based interaction between
          you and this Website.</span
        >
      </li>
      <li class="c9 c10 li-bullet-0">
        <span class="c0"
          >When you interact with our advertising and applications on
          third-party websites and services, if those applications or
          advertising include links to this policy.</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c0">It does not apply to information collected by:</span>
    </p>
    <ul class="c7 lst-kix_list_2-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0"
          >us offline or through any other means, including on any other website
          operated by The Card Professor Inc or any third party; or</span
        >
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0"
          >any third party, including through any application or content
          (including advertising) that may link to or be accessible from or on
          the Website.</span
        >
      </li>
    </ul>
    <h2 class="c4"><span class="c3">Use of Information</span></h2>
    <p class="c1">
      <span class="c0"
        >This Privacy Policy outlines the manner in which The Card Professor Inc
        (&quot;the Company&quot;) collects, uses, maintains, and discloses
        information collected from users (each, a &quot;User&quot;) of its
        services. The Company is committed to protecting the privacy and
        security of the information it collects and to being transparent about
        the ways in which that information is used.</span
      >
    </p>
    <p class="c1">
      <span
        >The Company may collect personal identification information from Users
        in a variety of ways, including, but not limited to, when Users visit
        our site, register on the site, place an order, subscribe to the
        newsletter, fill out a form, and in connection with other activities,
        services, features, or resources we make available. Users may be asked
        for, as appropriate, name, email address, mailing address, phone number,
        and credit card information. </span
      ><span
        >While certain portions of our Services may be accessed without
        providing personal identification information, the collection of such
        information may be necessary to use certain features or services. We
        will collect personal identification information from Users only with
        their consent or where we have another legal basis for processing such
        information under applicable law. Users should be aware that refusing to
        provide certain personal identification information may prevent them
        from accessing specific features or services.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >The Company uses the collected information for the following
        purposes:</span
      >
    </p>
    <ul class="c7 lst-kix_list_3-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0">To improve customer service</span>
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0">To personalize user experience</span>
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0">To improve our site</span>
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0">To process payments</span>
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0"
          >To send periodic emails regarding orders or other products and
          services</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c0"
        >By using the services provided by The Card Professor Inc, Users consent
        to the collection and use of their information as outlined in this
        Privacy Policy. The Company reserves the right to update this policy at
        any time. When we do, we will revise the updated date at the bottom of
        this page. We encourage Users to frequently check this page for any
        changes to stay informed about how we are helping to protect the
        personal information we collect. Your continued use of the service
        following the posting of changes to this policy will be deemed your
        acceptance of those changes.</span
      >
    </p>
    <h2 class="c4">
      <span class="c3">Information Sharing and Disclosure</span>
    </h2>
    <p class="c1">
      <span class="c0"
        >The Card Professor Inc (&quot;We&quot;, &quot;Us&quot;,
        &quot;Our&quot;) is committed to maintaining the privacy and protection
        of your personal identification information. This section outlines our
        practices regarding the sharing and disclosure of your personal
        identification information.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >We may share your personal identification information with third
        parties in the following situations:</span
      >
    </p>
    <ul class="c7 lst-kix_list_4-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0"
          >With service providers who assist us in our business operations and
          have agreed to keep the information confidential. These providers
          include, but are not limited to, payment processing, delivery of
          goods, and marketing assistance.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >When required by law, such as in response to a subpoena or similar
          legal process.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >In the event of a merger, acquisition, or sale of all or a portion of
          our assets, you will be notified via email and/or a prominent notice
          on our site of any change in ownership or uses of your personal
          identification information, as well as any choices you may have
          regarding your personal identification information.</span
        >
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0"
          >To any other third party with your prior consent to do so.</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c0"
        >Your personal identification information may also be disclosed if we
        believe in good faith that such disclosure is necessary to:</span
      >
    </p>
    <ul class="c7 lst-kix_list_5-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0">Protect our rights or property.</span>
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Investigate fraud or respond to a government request.</span
        >
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0">Protect the safety of Users or the public.</span>
      </li>
    </ul>
    <p class="c1">
      <span class="c0"
        >We will make every effort to ensure that any third party with whom we
        share your personal identification information will uphold and protect
        your information in accordance with this Privacy Policy and applicable
        laws.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Data Security</span></h2>
    <p class="c1">
      <span class="c0"
        >The Card Professor Inc (&quot;the Company&quot;) is committed to
        protecting the security of your personal identification information. We
        implement a variety of security measures to maintain the safety of your
        personal information when you enter, submit, or access your personal
        information.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >These security measures include, but are not limited to, the use of
        secure server software (SSL) which encrypts all information you input
        before it is sent to us, and secure databases to store your personal
        information. Only authorized employees, agents, and contractors (who
        have agreed to keep information secure and confidential) have access to
        this information. All emails and newsletters from this site allow you to
        opt out of further mailings.</span
      >
    </p>
    <p class="c1">
      <span
        >The Company will notify Users and relevant supervisory authorities of
        any data breach that affects personal identification information in
        accordance with applicable law, including without undue delay and, where
        required by law, within 72 hours of becoming aware of such breach. Such
        notification will include the nature of the breach, likely consequences,
        measures taken or proposed to address the breach, and contact
        information for inquiries, unless the personal data breach is unlikely
        to result in a risk to the rights and freedoms of natural persons.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Your Rights</span></h2>
    <p class="c1">
      <span class="c0"
        >As a User of The Card Professor Inc services, you have the right
        to:</span
      >
    </p>
    <ul class="c7 lst-kix_list_6-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0"
          >Be informed about how your personal identification information is
          being used.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Access the personal identification information about you that is held
          by The Card Professor Inc.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Request the correction of inaccurate personal identification
          information held about you by The Card Professor Inc.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Request the deletion of your personal identification information when
          it is no longer necessary for The Card Professor Inc to retain such
          data.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Object to the processing of your personal identification information
          by The Card Professor Inc in certain circumstances.</span
        >
      </li>
      <li class="c1 c9 li-bullet-0">
        <span class="c0"
          >Request that The Card Professor Inc restrict the processing of your
          personal identification information under certain circumstances.</span
        >
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0"
          >Request the transfer of your personal identification information to
          another party.</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c0"
        >This Privacy Policy is governed by the laws of Lake County, Illinois.
        If you have any questions or concerns about our use of your personal
        identification information, please contact us at the provided contact
        details.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Third-Party Services</span></h2>
    <p class="c1">
      <span class="c0"
        >The Card Professor Inc (&quot;We&quot;, &quot;Us&quot;, or
        &quot;Our&quot;) may engage third-party service providers (&quot;Service
        Providers&quot;) to perform various functions on Our behalf. These
        functions include, but are not limited to, hosting and maintaining Our
        website, processing payments, conducting analysis or research, and
        assisting with marketing efforts. When engaging such Service Providers,
        We may share User&#39;s personal identification information with them to
        the extent necessary for them to perform their services.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >We require all Service Providers to adhere to strict confidentiality
        obligations and to implement adequate security measures, including SSL
        encryption, to protect the personal identification information they
        process on Our behalf. Despite these precautions, We cannot guarantee
        the security of User&#39;s personal identification information against
        all potential security breaches.</span
      >
    </p>
    <p class="c1">
      <span
        >Users should be aware that some Service Providers may be located or
        operate in jurisdictions outside of Lake County, Illinois, and the
        United States. Any international transfer of personal identification
        information will be conducted in accordance with applicable data
        protection laws, including but not limited to the implementation of
        appropriate safeguards such as Standard Contractual Clauses, adequacy
        decisions, or other legally recognized transfer mechanisms. Users&#39;
        personal identification information may be subject to the laws of the
        jurisdictions in which those Service Providers operate.</span
      ><span class="c0"
        >&nbsp;By using Our services, Users consent to the transfer of their
        personal identification information to these jurisdictions.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >We do not sell, trade, or otherwise transfer to outside parties
        User&#39;s personal identification information without User consent,
        except as described in this Privacy Policy. This does not include
        website hosting partners and other parties who assist Us in operating
        Our website, conducting Our business, or serving Our Users, so long as
        those parties agree to keep this information confidential.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Children&#39;s Privacy</span></h2>
    <p class="c1">
      <span class="c0"
        >The Card Professor Inc recognizes the importance of protecting the
        privacy of children in the interactive online world. The services
        provided by The Card Professor Inc are not designed for or intentionally
        targeted at children under the age of 13 years. It is not our policy to
        intentionally collect or maintain information about anyone under the age
        of 13.</span
      >
    </p>
    <p class="c1">
      <span
        >No part of our website is structured to attract anyone under the age of
        13. Consistent with the Children&#39;s Online Privacy Protection Act
        (COPPA), we will never knowingly request personal identification
        information from anyone under the age of 13 without requiring parental
        consent. </span
      ><span
        >If we become aware that a child under 13 has provided us with personal
        identification information without verifiable parental consent, we will
        promptly: (1) delete all personal identification information collected
        from the child, (2) terminate the child&#39;s account, (3) notify and
        obtain verification from the child&#39;s parent or guardian, and (4)
        maintain records of such incidents as required by applicable law.</span
      >
    </p>
    <p class="c1">
      <span class="c0"
        >For the purpose of this clause, User refers to an individual who uses
        the services provided by The Card Professor Inc, and personal
        identification information is information that can be used on its own or
        with other information to identify, contact, or locate a single person,
        or to identify an individual in context.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Changes to This Privacy Policy</span></h2>
    <p class="c1">
      <span class="c0"
        >The Card Professor Inc reserves the right to update or change our
        Privacy Policy at any time and you should check this Privacy Policy
        periodically. Your continued use of the service provided by The Card
        Professor Inc after we post any modifications to the Privacy Policy on
        this page will constitute your acknowledgment of the modifications and
        your consent to abide and be bound by the modified Privacy Policy.</span
      >
    </p>
    <p class="c1">
      <span
        >If we make any material changes to this Privacy Policy, we will notify
        you at least 30 days prior to the changes taking effect either through
        the email address you have provided us, or by placing a prominent notice
        on our website. Where required by applicable law, we will obtain your
        consent before implementing material changes. Your continued use of our
        Services after such changes become effective constitutes your
        acknowledgment and acceptance of the modified Privacy Policy, where
        permitted by law.</span
      >
    </p>
    <h2 class="c4"><span class="c3">Contact Information</span></h2>
    <p class="c1">
      <span class="c0"
        >If you have any questions or concerns regarding this Privacy Policy or
        the handling of your personal identification information by The Card
        Professor Inc, please contact us at the following:</span
      >
    </p>
    <ul class="c7 lst-kix_list_7-0 start">
      <li class="c8 li-bullet-0">
        <span class="c0">Email: attorney&#64;sjustinbrown.com</span>
      </li>
      <li class="c10 c9 li-bullet-0">
        <span class="c0"
          >Postal Address: The Card Professor Inc, 829 Waukegan Road, Deerfield,
          IL 60015</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c0"
        >Our dedicated team is committed to addressing your inquiries and
        providing the necessary assistance regarding your privacy rights and the
        information collected by us.</span
      >
    </p>
  </div>
</div>
